<template>
  <div>
    <slot></slot>
    <p v-if="!hasARelationOfCorrectType">Please create a <b>{{ObjectModelRelationDefinition.getDisplayName(ObjectModelRelationType.OneToOne)}}</b> or <b>{{ObjectModelRelationDefinition.getDisplayName(ObjectModelRelationType.ManyToOne)}}</b> relationship to configure this field.</p>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import propertyBaseMixin from "../mixins/property-base-mixin";
  import {ObjectModelRelationType} from '~/enums/objectModelRelationType';
  import ObjectModelRelationDefinition from "~/models/objectModelRelations/objectModelRelationDefinition";

  export default Vue.extend({
    mixins: [propertyBaseMixin],
    data: function () {
      return {
        ObjectModelRelationType,
        ObjectModelRelationDefinition,
      };
    },
    computed: {
      hasARelationOfCorrectType(): boolean {
        return this.objectModelProperty.objectModel.mappableObjectModelRelationsFor(this.objectModelProperty).length > 0;
      },
    }
  });
</script>
